import type React from "react";

interface HeaderProps {
  activeTab: "tenants" | "domains" | "billing" | "audit";
  onTabChange: (tab: "tenants" | "domains" | "billing" | "audit") => void;
}

export const Header: React.FC<HeaderProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: "tenants", label: "Tenant Fleet" },
    { id: "domains", label: "Custom Domains (SaaS)" },
    { id: "billing", label: "Billing & Plans" },
    { id: "audit", label: "Audit Log" },
  ] as const;

  return (
    <header
      style={{
        padding: "16px 24px",
        backgroundColor: "#0f172a",
        borderBottom: "1px solid #334155",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <h1
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: 700,
            color: "#f8fafc",
            letterSpacing: "-0.02em",
          }}
        >
          Downline Instance Control Plane
        </h1>
        <div style={{ display: "flex", gap: "6px" }}>
          <span
            style={{
              fontSize: "11px",
              padding: "2px 6px",
              borderRadius: "4px",
              backgroundColor: "#1e293b",
              color: "#94a3b8",
              fontFamily: "monospace",
            }}
          >
            plane=instance
          </span>
          <span
            style={{
              fontSize: "11px",
              padding: "2px 6px",
              borderRadius: "4px",
              backgroundColor: "#1e293b",
              color: "#94a3b8",
              fontFamily: "monospace",
            }}
          >
            P1–P11
          </span>
        </div>
      </div>

      <nav style={{ display: "flex", gap: "8px" }}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              style={{
                padding: "8px 14px",
                fontSize: "13px",
                fontWeight: isActive ? 600 : 500,
                color: isActive ? "#38bdf8" : "#94a3b8",
                backgroundColor: isActive ? "#1e293b" : "transparent",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </nav>
    </header>
  );
};
